import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";

const STYLES = {
  ouvert: { bg: "bg-[#FCE7F3]", text: "text-[#A60F6E]", dot: "#D81B8C" },
  reserve: { bg: "bg-[#EFE3F5]", text: "text-[#6B2C8F]", dot: "#6B2C8F" },
  offert: { bg: "bg-[#E8F6E5]", text: "text-[#206F18]", dot: "#3FA535" },
};

export default function StatusBadge({ status, className = "" }) {
  const { t } = useLanguage();
  const style = STYLES[status] || STYLES.ouvert;
  return (
    <span
      data-testid={`badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest ${style.bg} ${style.text} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: style.dot }} />
      {t(`badges.${status}`)}
    </span>
  );
}
